import b from 'b_';
import cx from 'classnames';
import throttle from 'lodash/throttle';
import React from 'react';

import './scroll-block.scss';

const THROTTLE_WAIT = 300;

interface Props {
    mix?: string;
    children: React.ReactNode | Array<React.ReactNode>;
}

interface State {
    top: boolean;
    bottom: boolean;
}

export class ScrollBlock extends React.Component<Props, State> {
    state = {
        top: false,
        bottom: false,
    };

    componentDidMount(): void {
        setTimeout(this.setScrollPosition, 0);
    }

    block: HTMLElement | null = null;

    setBlockRef = (ref: HTMLDivElement | null) => {
        if (ref) {
            this.block = ref;
        }
    };

    onScroll = throttle(() => {
        this.setScrollPosition();
    }, THROTTLE_WAIT);

    setScrollPosition = () => {
        if (!this.block) {
            return;
        }

        const { scrollHeight, scrollTop, clientHeight } = this.block;

        if (scrollHeight > clientHeight) {
            const isScrolledTop = scrollTop === 0;
            const isScrolledBottom = clientHeight + scrollTop === scrollHeight;

            this.setState({
                top: !isScrolledTop,
                bottom: !isScrolledBottom,
            });
        } else if (scrollHeight === clientHeight) {
            this.setState({
                top: false,
                bottom: false,
            });
        }
    };

    render() {
        const { children, mix } = this.props;
        const { top, bottom } = this.state;

        return (
            <div className={cx(mix, 'scroll-block')}>
                <div className={b('scroll-block', 'shadow', { top, bottom })} />
                <div className="scroll-block__content" onScroll={this.onScroll} ref={this.setBlockRef}>
                    {children}
                </div>
            </div>
        );
    }
}

export default ScrollBlock;
